<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت ویژگیهای قیمت</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;ویژگی جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingItems" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.id)" dark v-if="!item.status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.id)" dark v-else> فعال</v-btn>
                            </template>
                            
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-btn text icon small color="orange accent-4" @click="AddAnswer(item)"><v-icon small>fas fa-list</v-icon></v-btn>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New Cat From Dialog-->
            <v-dialog max-width="500" persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت ویژگی جدید</span>
                              <span v-else>ویرایش ویژگی  &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="cancelEditItem()" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;padding-top:0px !important;"><!--Register New Color From-->
                                    <v-autocomplete multiple color="#2a2d45" v-model="SelectedCategories" :items="CategoryItems" item-text="pC_Title" item-value="pC_Id" outlined dense  label="دسته بندی" ></v-autocomplete>
                                    <v-text-field color="#2a2d45" outlined dense v-model="Title" label="عنوان" ></v-text-field>
                                   
                                    <v-text-field style="direction:ltr !important"  color="#2a2d45" outlined dense v-model="Sort" label="ترتیب نمایش" ></v-text-field>

                                    <v-row>
                                        <v-col cols="8">قابلیت انتخاب رنگ :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="ColorAbleAttr" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="AttrStatus" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>
                                   
                                   

                                  

                                    <v-btn style="margin-top:20px;" @click="registerItem" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template>
            <v-dialog v-model="AddAnswerDialog" fullscreen>
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">
                                <span v-if="!inEditingItem">ثبت آپشن جدید</span>
                                <span v-else>ویرایش آپشن  &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="AddAnswerDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md5 lg5 xl5 class="pa-5">
                                <v-text-field color="#2a2d45" outlined dense v-model="form.title" label="عنوان" ></v-text-field>
                                <v-text-field style="direction:ltr !important"  color="#2a2d45" outlined dense v-model="form.sort" label="ترتیب نمایش" ></v-text-field>
                                <custom-picker v-if="ColorAbleAttrSelected" @Selected="form.color = $event" :color="form.color" label="رنگ"></custom-picker>
                                <v-row>
                                    <v-col cols="8">وضعیت :</v-col>
                                    <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                        <v-switch v-model="form.status" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                    </v-col>
                                </v-row>
                                <v-btn style="margin-top:20px;" @click="registerAnswer" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                            </v-flex>
                            <v-flex xs12 sm12 md7 lg7 xl7 class="pa-5">
                                <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingItems" :headers="AnswerTableHeader"  :items="AnswerTableItems">
                                    <template v-slot:[`item.status`]="{ item }">
                                    <v-btn small text color="#D32F2F" @click="ActiveAnswerItem(item.id)" dark v-if="!item.status">غیر فعال</v-btn>
                                    <v-btn small text color="#2E7D32" @click="DisableAnswerItem(item.id)" dark v-else> فعال</v-btn>
                                    </template>
                                    <template v-slot:[`item.operation`]="{ item }">
                                        <v-btn text icon small color="blue accent-4" @click="editAnswerItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                        <v-btn text icon small color="red accent-4" @click="DeleteAnswerItem(item.id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>
<style>
.v-color-picker__canvas canvas
{
    display: block !important;
    min-width: 100% !important;
    height: 100% !important;
}
</style>
<script>
const AnswerFormDefault = Object.freeze({
    title:"",
    sort:"",
    status:true,
    attrId:0,
    color:"#ffffff"
});
const axios = require("axios");
const ApiUrl = require('../../constant/apiurl');
const MSGHNDL = require('../../constant/MessageHandler');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
export default {
   name:"valueableattribute",
   components: 
   {
      Loading,
      JsonExcel
        
    },
    data:()=> ({
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        CatCreationDialog:false,
        searchcategory:"",
        isLoadingItems:false,
        AttrStatus:false,
        ColorAbleAttr:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان ",value:"title",sortable:true,align:"right"},
            {text:"ترتیب نمایش",value:"sort",sortable:true,align:"right"},
            {text:"وضعیت",value:"status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        AnswerTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان ",value:"title",sortable:true,align:"right"},
            {text:"ترتیب نمایش",value:"sort",sortable:true,align:"right"},
            {text:"وضعیت",value:"status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        AnswerTableItems:[],
        Title:"",
        Sort:"",
        originalItems:[],
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "کد":"id",
            "عنوان":"title",
            "ترتیب نمایش":"sort",
            "وضعیت":"status"
        },
        AddAnswerDialog:false,
        form:Object.assign({},AnswerFormDefault),
        CategoryItems:[],
        SelectedAttrId:0,
        inEditAnswer:false,
        SelectedCategories:[],
        ColorAbleAttrSelected:false
    }),
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadItems();
        }
    },
    async created()
    {
        let vm = this;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadItems();
       await this.LoadCategories();
    },
    methods:{
        closeAnswerDialog()
        {
            let vm = this;
            vm.form = Object.assign({},AnswerFormDefault);
            vm.AddAnswerDialog = false;
            vm.AnswerTableItems = [];
        },
        async DeleteAnswerItem(id)
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.Id = id;
            await axios.post(ApiUrl.DeleteVAAttribute,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadAnswerItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        editAnswerItem(item)
        {
            let vm = this;
            vm.form = item;
            vm.inEditAnswer = true;
        },
        async LoadCategories()
        {
            let vm = this;
            vm.isLoadingItems = true;

            await axios.post(ApiUrl.getCategoiesOfFinalLevelCombo).then((res)=>{
                vm.isLoadingItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CategoryItems = data.data;
                    console.warn(data.data);
                    
                }
            }).catch((err)=>{
                vm.isLoadingItems = false;
                console.error(err);
            });
        },
        async AddAnswer(item)
        {
            let vm = this;
            console.warn("ITEM",item);
            vm.AddAnswerDialog = true;
            vm.form.AttrId =item.id; 
            vm.ColorAbleAttrSelected = item.colorable;
            vm.SelectedAttrId = item.id;
            await vm.loadAnswerItems();
        },
        cancelEditAnswerItem()
        {
            let vm = this;
            vm.form = Object.assign({},AnswerFormDefault);
            vm.form.AttrId =vm.SelectedAttrId; 
            vm.inEditAnswer = false;
        },
       async registerAnswer()
       {
           let vm = this;
            
            let url = ApiUrl.registerVAAttribute;
            if(vm.inEditAnswer)
            {
                url = ApiUrl.updateVAAttribute;
            }
            await axios.post(url,vm.form).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadAnswerItems();
                    vm.cancelEditAnswerItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
       },
       async loadAnswerItems()
        {
            let vm = this;
            vm.isLoadingItems = true;

            await axios.post(ApiUrl.LoadVAAttributes,{AttrId : vm.SelectedAttrId}).then((res)=>{
                vm.isLoadingItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.AnswerTableItems = data.data;
                    console.warn(data.data);
                    
                }
            }).catch((err)=>{
                vm.isLoadingItems = false;
                console.error(err);
            });
        },
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteVAttribute,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async DisableAnswerItem(id)
        {
            let vm = this;
            let Model = {};
            Model.Id = id;
            await axios.post(ApiUrl.DisableVAAttribute,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadAnswerItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async ActiveAnswerItem(id)
        {
            let vm = this;
            let Model = {};
            Model.Id = id;
            await axios.post(ApiUrl.ActiveVAAttribute,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadAnswerItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.Id = id;
            await axios.post(ApiUrl.ActiveVAttribute,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.Id = id;
            await axios.post(ApiUrl.DisableVAttribute,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadItems();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.Title = "";
            vm.Sort = "";
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
            vm.SelectedCategories = [];
        },
        editItem(item)
        {
            let vm = this;
            vm.CatCreationDialog = true;
            vm.Title = item.title;
            vm.Sort = item.sort;
            vm.AttrStatus = item.status;
            vm.ColorAbleAttr = item.colorable;
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
            vm.SelectedCategories = [];
            item.categories.forEach(item=>{
                vm.SelectedCategories.push(item.categoryId);
            });
        },
        async loadItems()
        {
            let vm = this;
            vm.isLoadingItems = true;

            await axios.post(ApiUrl.LoadVAttributes).then((res)=>{
                vm.isLoadingItems = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                    
                    console.warn(data.data);
                    
                }
            }).catch((err)=>{
                vm.isLoadingItems = false;
                console.error(err);
            });
        },
        async registerItem()
        {
            let vm = this;
            let Model = {};

            if(vm.SelectedCategories.length < 1)
            {
                MSGHNDL.ERR("دسته بندی انتخاب نشده است");
                return;
            }
            
            
            Model.Title = vm.Title;
            Model.Sort = vm.Sort;
            Model.Status = vm.AttrStatus;
            Model.Colorable = vm.ColorAbleAttr;
            let url = ApiUrl.registerVAttribute;
            if(vm.inEditingItem)
            {
                Model.Id = vm.EditSelectedItem.id;
                url = ApiUrl.updateVAttribute;
                var categories = [];
                vm.SelectedCategories.forEach(item=>{
                    categories.push({CategoryId :item ,AttributeId : Model.Id});
                    Model.Categories = categories;
                });

            }
            else
            {
                var categories = [];
                vm.SelectedCategories.forEach(item=>{
                    categories.push({CategoryId :item });
                    Model.Categories = categories;
                });
            }
            console.warn(Model);
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadItems();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        }
    }
}
</script>